import React, { useEffect, useState, useRef } from "react"
import IosShareIcon from '@mui/icons-material/IosShare';

export default function CategoryDateShare({ category, post }) {
  const [canShare, setCanShare] = useState(false)
  const shareRef = useRef(null)

  let shareData = {
    title: post.title,
    text: post.description,
    url: 'https://laxus.co/magazine/posts/' + post.postId
  }

  useEffect(() => {
    if (typeof navigator !== "undefined" && navigator.share !== undefined) {
      setCanShare(true)
    }
  }, [])

  const handleShare = async () => {
    try {
      await navigator.share(shareData)
    } catch(err) {
    }
  }

  return (
    <p className="category-date-share">
      <span className="category">{category.nameJA}</span>
      <span>/</span>
      <span className="date">{post.postedAt.substr(0, 10).replace(/-/g, '/')}</span>
      {canShare && (
        <IosShareIcon className="share" sx={{ fontSize: 30 }} onClick={handleShare} ref={shareRef} />
      )}
    </p>
  )
}